<template>
    <div>
        <CoronaInfo></CoronaInfo>

        <ProfilePicture/>

        <Search></Search>
        <Facts></Facts>

        <LastBookingsCard></LastBookingsCard>

        <router-view></router-view>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Search from '@/components/Search';
    import Facts from "@/components/Facts";
    import CoronaInfo from "@/components/CoronaInfo";
    import LastBookingsCard from "@/components/cards/LastBookingsCard";
    import ProfilePicture from "../components/ProfilePicture";

    export default {
        name: "Start",
        components: {CoronaInfo, Search, Facts, LastBookingsCard, ProfilePicture},
        computed: {
            ...mapGetters('auth', {
                'loggedIn': 'loggedIn',
                'user': 'user'
            }),
        },
        async mounted() {
            if (this.loggedIn) {
                await this.$store.dispatch('auth/filter');
                await this.$store.dispatch('mission/filter');
            } else {
                await this.$store.dispatch('auth/anonymisedFilter');
                await this.$store.dispatch('mission/anonymisedFilter');
            }
        }
    }
</script>

<style scoped>

</style>